// src/pages/index.ts —— 页定义注册表：各页文件只替换自身内容，不改本文件（页文件两两不相交）
import { PAGES_CRYPTO } from './crypto';
import { PAGES_AGENTS } from './agents';
import { PAGES_BUDGETS } from './budgets';
import { PAGES_CARDS } from './cards';
import { PAGES_FUNDS } from './funds';
import { PAGES_OPS } from './ops';
import { PAGES_PAYOUT } from './payout';
import { PAGES_PLATFORM } from './platform';
import { PAGES_PRODUCTS } from './products';
import { PAGES_PROFIT } from './profit';
import { PAGES_SHELLS } from './shells';
import { PAGES_TGBOT } from './tgbot';
import { PAGES_USERS } from './users';
import type { PageDef, PageMap } from './types';
import type { Page } from '../state';

// 后序覆盖前序：页面接通后由所属页文件的 PAGES_X 注册同名页，覆盖 PAGES_SHELLS 中的搭壳定义（products 页恒由 PAGES_PRODUCTS 承载）
export const ALL_PAGES: PageMap = { ...PAGES_SHELLS, ...PAGES_PRODUCTS, ...PAGES_CARDS, ...PAGES_BUDGETS, ...PAGES_FUNDS, ...PAGES_AGENTS, ...PAGES_USERS, ...PAGES_OPS, ...PAGES_PAYOUT, ...PAGES_PLATFORM, ...PAGES_TGBOT, ...PAGES_CRYPTO, ...PAGES_PROFIT };

// null = 本页尚未迁移，表格 / 抽屉 / 表单 / 确认框走影子实例透传（TD-824）
export function pageDefOf(page: Page): PageDef | null {
  return ALL_PAGES[page] ?? null;
}
